exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".polis-text[data-v-71fc38d6]{white-space:pre-wrap;font-size:14px;padding-top:5px}@media(min-width:960px){.polis-text[data-v-71fc38d6]{padding-top:2px}}.text-red[data-v-71fc38d6]{color:#ff5252}.text-yellow[data-v-71fc38d6]{color:#b7b708}.text-green[data-v-71fc38d6]{color:#00ba57}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71fc38d6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/elements/OsagoInsuranceConditions.vue
// module id = YlmR
// module chunks = 0 1